module.exports = __webpack_public_path__ + "static/media/Joseph.bf2b4c18.JPG";